export type FirmwareOption = {
  id: string;
  label: string;
  url: string;
};

export type FirmwareCatalog = Record<string, FirmwareOption[]>;

export const firmwareCatalog: FirmwareCatalog = {
  esp32c3: [
    {
      id: "xpb_v1.1.4",
      label: "XPB v1.1.4",
      url: "http://127.0.0.1:5500/XPBFlasher/src/firmware/esp32c3_xpb_v1.1.4.bin",
    },
  ],
  esp32c6: [
    {
      id: "xpb_v1.1.4",
      label: "XPB v1.1.4",
      url: "https://github.com/nicho810/XIAO-PowerBread/releases/download/v1.1.4/esp32c6_xpb_v1.1.4.bin",
    },
  ],
  esp32s3: [
    {
      id: "xpb_v1.1.4",
      label: "XPB v1.1.4",
      url: "https://github.com/nicho810/XIAO-PowerBread/releases/download/v1.1.4/esp32s3_xpb_v1.1.4.bin",
    },
  ],
};

export function getPrimaryFirmware(target: string): FirmwareOption | null {
  const options = firmwareCatalog[target];
  if (!options || options.length === 0) return null;
  return options[0];
}
